export default __webpack_public_path__ + "09966887772ceed54298f3b1ff6b9b48.png";